<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'

interface AttrCarousel {
    imgUrl?: string | null;
    imgAlt?: string | null;
}

interface MyProp {
    component: string;
    attr: Array<AttrCarousel>;
}

const props: MyProp|{} = defineProps<{}>();

const currentImageIndex = ref(0)
let intervalId: NodeJS.Timeout;


const filteredImages = computed(() => {
    return Array.isArray(props.attr) ? props.attr?.filter(image => image.imgUrl != null) : [];
});

function startTimer() {
    intervalId = setInterval(nextImage, 5000);
}

function nextImage() {
    if (filteredImages.value.length > 0) {
        currentImageIndex.value = (currentImageIndex.value + 1) % filteredImages.value.length;
    }
}

onMounted(startTimer);
onUnmounted(() => clearInterval(intervalId));

const goToSlide = (index: number) => {
    currentImageIndex.value = index;
};
</script>

<template>
    <div class="relative overflow-hidden mx-auto w-full lg:w-[1144px]">
        <!-- Banner -->        
        <div class="relative rounded-lg">
            <img :src="filteredImages[currentImageIndex]?.imgUrl" :alt="filteredImages[currentImageIndex]?.imgAlt"
                class="flex-none w-full lg:max-h-[425px] d-block mx-auto mobile-max-h">
            <!-- Indicadores de Slide -->
            <div class="absolute inset-0 flex items-end justify-center pb-4">
                <span v-for="(_, index) in filteredImages" :key="index"
                    class="w-3 h-3 mx-2 transition-opacity duration-300 bg-white border-2 rounded-full cursor-pointer border-color-primary"
                    :class="{ 'opacity-100': currentImageIndex === index, 'opacity-50': currentImageIndex !== index }"
                    @click="goToSlide(index)"> 
                </span>
            </div>
        </div>
    </div>
</template>
